import * as React from "react";
import { Text, makeStyles, tokens } from "@fluentui/react-components";
import { PersonRegular, BotRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  row: {
    display: "flex",
    gap: "8px",
    padding: "4px 0",
  },
  rowUser: {
    flexDirection: "row-reverse",
  },
  rowAgent: {
    flexDirection: "row",
  },
  avatar: {
    flexShrink: 0,
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
  },
  avatarUser: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
  },
  avatarAgent: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
  },
  bubble: {
    maxWidth: "80%",
    padding: "8px 12px",
    borderRadius: "12px",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
  },
  bubbleUser: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    borderTopRightRadius: "4px",
  },
  bubbleAgent: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground1,
    borderTopLeftRadius: "4px",
  },
  timestamp: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground4,
    marginTop: "2px",
    paddingLeft: "36px",
    paddingRight: "36px",
  },
  timestampUser: {
    textAlign: "right",
  },
  timestampAgent: {
    textAlign: "left",
  },
});

export interface ChatMessageData {
  id: string;
  role: "user" | "agent";
  text: string;
  timestamp: Date;
  isFinal: boolean;
}

interface ChatMessageProps {
  message: ChatMessageData;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const styles = useStyles();
  const isUser = message.role === "user";

  return (
    <div>
      <div className={`${styles.row} ${isUser ? styles.rowUser : styles.rowAgent}`}>
        <div className={`${styles.avatar} ${isUser ? styles.avatarUser : styles.avatarAgent}`}>
          {isUser ? <PersonRegular /> : <BotRegular />}
        </div>
        <div className={`${styles.bubble} ${isUser ? styles.bubbleUser : styles.bubbleAgent}`}>
          <Text>{message.text}</Text>
        </div>
      </div>
      <div className={`${styles.timestamp} ${isUser ? styles.timestampUser : styles.timestampAgent}`}>
        <Text>
          {message.timestamp.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}
        </Text>
      </div>
    </div>
  );
};

export default ChatMessage;
